class GameAsync {
    /**
     * Get game
     * @param gameId
     * @return {Promise}
     */
    static get(gameId = '') {
        const HTTP = new Http();

        return new Promise((resolve, reject) => {
            HTTP.ajax({
                url: '/rso/' + gameId,
                type: 'GET'
            }).then((response) => {
                return resolve(response);
            }).catch(() => {
                return reject('There was a network error.');
            })
        });
    }

    /**
     * Post game data
     * @param formData
     * @return {Promise}
     */
    static post(formData) {
        const HTTP = new Http();

        return new Promise((resolve, reject) => {
            HTTP.ajax({
                url: '/rso',
                type: 'POST',
                formData: formData
            }).then((response) => {
                return resolve(response);
            }).catch(() => {
                return reject('There was a network error.');
            })
        });
    }
}